import React, {Component} from "react";
import {FormField} from "../../../../components/form";
import {SelectInput, TextInput} from "../../../../components";
import ValidationUtil from "../../../../components/form/validator/ValidationUtil";
import {DialogActions} from "@material-ui/core";
import {Button} from "react-bootstrap";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import InvoiceUpdateReasonEnum from "./enums/InvoiceUpdateReasonEnum";

export default class CancelInvoiceModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cancelReason: "",
            cancelDetail: ""
        };
    }

    confirm() {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        const {invoice, invoiceItem, patientId} = this.props;

        const apiUrl = invoiceItem
            ? 'api/billing/' + patientId + '/item/' + invoiceItem.id + '/cancel'
            : 'api/billing/invoice/' + invoice.id + '/cancel';

        RemotingService.postRemoteCall(
            apiUrl + '?reason=' + this.state.cancelReason + '&detail=' + this.state.cancelDetail,
            null,
            (result) => {
                this.props.close();
                this.props.onSave(result);
            });
    }

    render() {
        const {invoice, invoiceItem} = this.props;

        let label, isBilled;

        if (invoiceItem) {
            isBilled = 'BILLED' === invoiceItem.status;
            label = "You are about to cancel " + (isBilled ? 'a paid bill.' : 'an invoice item.') + " Are you sure?";
        } else if (invoice) {
            isBilled = 'BILLED' === invoice.status;
            label = "You are about to cancel " + (isBilled ? 'a billed invoice.' : 'an invoice.') + " Are you sure?";
        }

        this.formFields = [];

        return (
            <>
                <div className="container padding-10" style={{width: '600px'}}>
                    <div className="row mt-1">
                        {label}
                    </div>
                    <div className="row mt-1">
                        <div className="col-4 border">
                            <div>Reason</div>
                        </div>
                        <div className="col-8 border">
                            <FormField ref={formField => this.formFields.push(formField)}
                                       required
                                       validateOn={this.state.cancelReason}>
                                <SelectInput displayProperty="name" valueProperty="key" searchEnabled={false}
                                             value={this.state.cancelReason}
                                             options={InvoiceUpdateReasonEnum.toArray()}
                                             onChange={(cancelReason) => this.setState({cancelReason})}/>
                            </FormField>
                        </div>
                    </div>
                    {('OTHER' === this.state.cancelReason || 'REFUND' === this.state.cancelReason) &&
                        <div className="row mt-1">
                            <div className="col-4 border">
                                <div>Details</div>
                            </div>
                            <div className="col-8 border">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required
                                           validateOn={this.state.cancelDetail}>
                                    <TextInput value={this.state.cancelDetail}
                                               onChange={(value) => this.setState({cancelDetail: value})}
                                               placeholder="Please specify the details..."
                                               maxLength={500}
                                    />
                                </FormField>
                            </div>
                        </div>
                    }
                </div>
                <DialogActions>
                    <Button variant="success" onClick={() => this.confirm()}>Confirm</Button>
                </DialogActions>
            </>
        );
    }

}